import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from '../styles';

import { MessageBox, BannerNotif } from 'components';

const PromoBanner = ({ enabled, history, ...rest }) => {
  if (!enabled) return null;
  return (
    <MessageBox {...rest}>
      <BannerNotif history={history} primary />
    </MessageBox>
  );
};

export default withStyles(styles)(PromoBanner);
